import React from 'react';
import { Box, Link as MuiLink, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { COMPANY, LEGAL_LINKS, SUPPORT_EMAIL } from '../../constants/legal';

// 特商法表記・利用規約・プライバシーポリシーへの導線。アプリに共通レイアウトが無いため
// （App.jsx の Layout はコメントアウトされている）、主要ページのシェル側から個別に置く。
function LegalFooter({ sx }) {
  return (
    <Box
      component="footer"
      sx={{
        pt: 2.5,
        borderTop: '1px solid rgba(92, 160, 219, 0.16)',
        color: 'rgba(196, 224, 243, 0.68)',
        ...sx,
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={{ xs: 1, sm: 2.5 }}
        sx={{ flexWrap: 'wrap', alignItems: { xs: 'flex-start', sm: 'center' } }}
      >
        {LEGAL_LINKS.map((link) => (
          <MuiLink
            key={link.path}
            component={RouterLink}
            to={link.path}
            underline="hover"
            sx={{ fontSize: 13, color: 'inherit', '&:hover': { color: '#8fd8ff' } }}
          >
            {link.label}
          </MuiLink>
        ))}
        <MuiLink
          href={`mailto:${SUPPORT_EMAIL}`}
          underline="hover"
          sx={{ fontSize: 13, color: 'inherit', '&:hover': { color: '#8fd8ff' } }}
        >
          お問い合わせ
        </MuiLink>
      </Stack>

      <Typography sx={{ mt: 1.5, fontSize: 12, color: 'rgba(170, 202, 224, 0.52)' }}>
        {COMPANY.name}　本サービスは競馬に関する参考情報を提供するものであり、的中や利益を保証するものではありません。
      </Typography>
    </Box>
  );
}

export default LegalFooter;
